import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";
import PageHero from "./common/PageHero";
import CtaBand from "./common/CtaBand";

const UeberUns = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    const values = [
        {
            icon: 'fas fa-handshake',
            title: de ? 'Integrität' : 'Integridade',
            text: de
                ? 'Ehrlichkeit und Vertrauen stehen im Mittelpunkt unserer Geschäftsbeziehungen. Wir handeln stets in Ihrem besten Interesse.'
                : 'A honestidade e a confiança estão no centro das nossas relações comerciais. Agimos sempre no seu melhor interesse.'
        },
        {
            icon: 'fas fa-fire',
            title: de ? 'Engagement' : 'Compromisso',
            text: de
                ? 'Wir setzen uns mit Leidenschaft und Sorgfalt für Ihre Anliegen ein und streben danach, Ihre Erwartungen zu übertreffen.'
                : 'Empenhamo-nos com paixão e cuidado nas suas preocupações e esforçamo-nos por exceder as suas expectativas.'
        },
        {
            icon: 'fas fa-lock',
            title: de ? 'Vertraulichkeit' : 'Confidencialidade',
            text: de
                ? 'Der Schutz Ihrer Daten und Informationen hat für uns höchste Priorität. Ihre Anliegen sind bei uns in guten Händen.'
                : 'A proteção dos seus dados e informações é a nossa principal prioridade. As suas preocupações estão em boas mãos connosco.'
        },
        {
            icon: 'fas fa-bolt',
            title: de ? 'Effizienz' : 'Eficiência',
            text: de
                ? 'Durch strukturierte Arbeitsprozesse und moderne Lösungen optimieren wir Ihre Abläufe und sparen Ihnen wertvolle Zeit.'
                : 'Com processos estruturados e soluções modernas, otimizamos os seus fluxos de trabalho e poupamos-lhe tempo valioso.'
        }
    ];

    return (
        <div>
            <PageHero
                eyebrow={de ? 'Über uns' : 'Sobre nós'}
                title={de
                    ? <span>Ihr Partner für effiziente und <em>vertrauensvolle</em> Zusammenarbeit.</span>
                    : <span>O seu parceiro para uma cooperação eficiente e <em>de confiança</em>.</span>}
                lede={de
                    ? 'Wir sind ein dynamisches und engagiertes Team, spezialisiert darauf, Unternehmen und Privatpersonen in den Bereichen Büroservice, Hilfestellungen und Verwaltung den Rücken freizuhalten – damit Sie sich auf das Wesentliche konzentrieren können.'
                    : 'Somos uma equipa dinâmica e dedicada, especializada em apoiar empresas e particulares nas áreas de serviços de escritório, assistência e administração – para que se possa concentrar no essencial.'}
            />

            {/* Werte */}
            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-section__head">
                        <span className="tm-eyebrow">{de ? 'Unsere Werte' : 'Os nossos valores'}</span>
                        <h2 className="tm-section__title">
                            {de
                                ? <span>Das Fundament <em>unserer Arbeit</em>.</span>
                                : <span>A base do <em>nosso trabalho</em>.</span>}
                        </h2>
                        <p className="tm-section__lede">
                            {de
                                ? 'Professionalität, Verlässlichkeit und Transparenz – unsere Arbeit basiert auf vier Grundprinzipien.'
                                : 'Profissionalismo, fiabilidade e transparência – o nosso trabalho assenta em quatro princípios básicos.'}
                        </p>
                    </div>
                    <div className="tm-values">
                        {values.map((value, i) => (
                            <div key={i} className="tm-value">
                                <span className="tm-value__icon"><i className={value.icon}/></span>
                                <h3>{value.title}</h3>
                                <p>{value.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Warum & Mission */}
            <section className="tm-section tm-section--tight">
                <div className="tm-container">
                    <div className="tm-intro">
                        <div>
                            <span className="tm-eyebrow">{de ? 'Warum Tomé & Martins?' : 'Porquê a Tomé & Martins?'}</span>
                            <p className="tm-intro__statement">
                                {de
                                    ? <span>Eine Brücke zwischen <em>Kulturen und Märkten</em> – Deutschland und Portugal.</span>
                                    : <span>Uma ponte entre <em>culturas e mercados</em> – Alemanha e Portugal.</span>}
                            </p>
                        </div>
                        <div className="tm-intro__body">
                            <p>
                                {de
                                    ? 'Mit Standorten in Deutschland und Portugal verstehen wir uns als Brücke zwischen verschiedenen Kulturen und Märkten. Diese internationale Perspektive macht uns zum idealen Partner für Unternehmen, die lokal und global erfolgreich agieren möchten.'
                                    : 'Com escritórios na Alemanha e em Portugal, consideramo-nos uma ponte entre diferentes culturas e mercados. Esta perspetiva internacional faz de nós o parceiro ideal para empresas que pretendem operar com sucesso a nível local e global.'}
                            </p>
                            <p>
                                {de
                                    ? 'Unser Team besteht aus hochqualifizierten Fachleuten mit langjähriger Erfahrung. Wir kombinieren Fachwissen mit einem breit gefächerten Netzwerk und arbeiten eng mit Experten aus verschiedenen Branchen zusammen. Unsere Kunden schätzen dabei vor allem eines: die persönliche Herangehensweise. Bei uns stehen Sie als Mensch im Mittelpunkt.'
                                    : 'A nossa equipa é composta por especialistas altamente qualificados com muitos anos de experiência. Combinamos conhecimento especializado com uma vasta rede e trabalhamos em estreita colaboração com peritos de vários setores. Os nossos clientes valorizam sobretudo uma coisa: a abordagem pessoal. Connosco, a pessoa está no centro.'}
                            </p>
                            <p>
                                {de
                                    ? 'Unsere Mission: durch maßgeschneiderte Dienstleistungen Mehrwert schaffen und eine vertrauensvolle, langfristige Zusammenarbeit aufbauen. Mit Tomé & Martins haben Sie einen Partner an Ihrer Seite, der Ihre Herausforderungen versteht – und die Lösungen bietet, die Sie benötigen.'
                                    : 'A nossa missão: criar valor acrescentado através de serviços personalizados e construir uma cooperação de confiança a longo prazo. Com a Tomé & Martins, tem ao seu lado um parceiro que compreende os seus desafios – e oferece as soluções de que necessita.'}
                            </p>
                            <p className="tm-intro__signature">
                                {de ? '— Gemeinsam mehr erreichen.' : '— Conseguir mais em conjunto.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Brücke */}
            <section className="tm-section tm-section--tight">
                <div className="tm-container">
                    <div className="tm-bridge">
                        <div className="tm-bridge__grid">
                            <div className="tm-bridge__country">
                                <span>{de ? 'Verwurzelt in' : 'Enraizados em'}</span>
                                <h3>Bodenheim, Deutschland</h3>
                                <p>
                                    {de
                                        ? 'Seit über zwei Jahrzehnten begleiten wir Unternehmen und Privatpersonen im Rhein-Main-Gebiet – persönlich und zuverlässig.'
                                        : 'Há mais de duas décadas que acompanhamos empresas e particulares na região Reno-Meno – de forma pessoal e fiável.'}
                                </p>
                            </div>
                            <div className="tm-bridge__divider">
                                <i className="fas fa-exchange-alt"/>
                            </div>
                            <div className="tm-bridge__country">
                                <span>{de ? 'Verbunden mit' : 'Ligados a'}</span>
                                <h3>Portugal</h3>
                                <p>
                                    {de
                                        ? 'Sprache, Kultur und ein gewachsenes Netzwerk aus Steuerberatern und Anwälten – für alle, die den Schritt über die Grenze wagen.'
                                        : 'Língua, cultura e uma rede consolidada de consultores fiscais e advogados – para todos os que dão o passo além-fronteiras.'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CtaBand/>
        </div>
    );
}

export default UeberUns;



// WEBPACK FOOTER //
// ./src/components/UeberUns.js